import { applyMiddleware,createStore } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import Reducers from './Reducer';

const middleware = [thunk]

const store = createStore(Reducers,composeWithDevTools(applyMiddleware(...middleware)))

export default store